
export function toggleActiveToolButton(element, childElement) {
    document.querySelectorAll('.btn-tools').forEach(element => {
        element.classList.remove('active')
    })
    hideActiveToolButtons()
    if(element) {
        element.closest('label').classList.add('active')
    }

    if(document.querySelector(childElement)) {
        document.querySelector(childElement).classList.remove('d-none')
    }
}

export function hideActiveToolButtons() {
    document.querySelectorAll('.layer-info-tool-button').forEach(element => {
        element.classList.add('d-none')
    })
}
